import { categoryLabel } from "@/domains/freelance/taxonomy/store/taxonomy-store";

/**
 * Category line shown on freelancer cards: "primary · secondary" when the
 * freelancer has a secondary category, the primary label alone otherwise.
 * Labels come from the taxonomy (falling back to the raw key when the tree is
 * not loaded). A secondary that resolves to the same label is not repeated.
 */
export function categoryLine(
  primary?: string | null,
  secondary?: string | null,
): string | null {
  if (!primary) return null;
  const primaryLabel = categoryLabel(primary);
  if (!secondary) return primaryLabel;
  const secondaryLabel = categoryLabel(secondary);
  if (secondaryLabel === primaryLabel) return primaryLabel;
  return `${primaryLabel} · ${secondaryLabel}`;
}
